import { UUID } from "crypto";
import { useQuery } from "@tanstack/react-query";
import { getStudyMetadata } from "../../api/dataSources";
import useUserContext from "../Authorization/useUserContext";
import { Study } from "./models";

// Its not ideal that we have both this and useStudyStore, since we have two different models for a Study
export default function useStudyMetadataStore(study_guid?: UUID) {
  const user = useUserContext();

  // TODO: Modify Study model to have computed `study_format` property that matches how its hydrates in the MarketResearchStudy model Python side
  const MetadataQuery = useQuery<Study>({
    queryKey: ["pmr:study_metadata", study_guid],
    queryFn: () => getStudyMetadata(user, study_guid as string),
    enabled: !!study_guid,
  });

  const { data: study, isLoading } = MetadataQuery;

  return {
    MetadataQuery, // I'm not sold on returning this directly
    study,
    isLoading,
  };
}
